export const list = [
  {
    countryLabel: "Afghanistan",
    label: "Afghani",
    code: "AFG"
  },
  {
    countryLabel: "Albania",
    label: "Albanian",
    code: "ALB"
  },
  {
    countryLabel: "Algeria",
    label: "Algerian",
    code: "DZA"
  },
  {
    countryLabel: "USA",
    label: "American",
    code: "USA"
  },
  {
    countryLabel: "Andorra",
    label: "Andorran",
    code: "AND"
  },
  {
    countryLabel: "Angola",
    label: "Angolan",
    code: "AGO"
  },
  {
    countryLabel: "Anguilla",
    label: "Anguillan",
    code: "AIA"
  },
  {
    countryLabel: "Antigua & Barbuda",
    label: "Antiguan",
    code: "ATG"
  },
  {
    countryLabel: "Argentina",
    label: "Argentine",
    code: "ARG"
  },
  {
    countryLabel: "Armenia",
    label: "Armenian",
    code: "ARM"
  },
  {
    countryLabel: "Aruba",
    label: "Arubian",
    code: "ABW"
  },
  {
    countryLabel: "Australia",
    label: "Australian",
    code: "AUS"
  },
  {
    countryLabel: "Austria",
    label: "Austrian",
    code: "AUT"
  },
  {
    countryLabel: "Azerbaijan",
    label: "Azerbaijani",
    code: "AZE"
  },
  {
    countryLabel: "Bahamas",
    label: "Bahameese",
    code: "BHS"
  },
  {
    countryLabel: "Bahrain",
    label: "Bahrainian",
    code: "BHR"
  },
  {
    countryLabel: "Bangladesh",
    label: "Bangladeshi",
    code: "BGD"
  },
  {
    countryLabel: "Barbados",
    label: "Barbadian",
    code: "BRB"
  },
  {
    countryLabel: "Belarus",
    label: "Belarusian",
    code: "BLR"
  },
  {
    countryLabel: "Belgium",
    label: "Belgian",
    code: "BEL"
  },
  {
    countryLabel: "Belize",
    label: "Belizean",
    code: "BLZ"
  },
  {
    countryLabel: "Benin",
    label: "Beninese",
    code: "BEN"
  },
  {
    countryLabel: "Bermuda",
    label: "Bermudan",
    code: "BMU"
  },
  {
    countryLabel: "Bhutan",
    label: "Bhutanese",
    code: "BTN"
  },
  {
    countryLabel: "Bolivia",
    label: "Bolivian",
    code: "BOL"
  },
  {
    countryLabel: "Bonaire",
    label: "Bonaire",
    code: "BES"
  },
  {
    countryLabel: "Bosnia and Herzegovina",
    label: "Bosnian",
    code: "BIH"
  },
  {
    countryLabel: "Brazil",
    label: "Brazilian",
    code: "BRA"
  },
  {
    countryLabel: "Great Britain",
    label: "British",
    code: "GBR"
  },
  {
    countryLabel: "Brunei",
    label: "Bruneian",
    code: "BRN"
  },
  {
    countryLabel: "Bulgaria",
    label: "Bulgarian",
    code: "BGR"
  },
  {
    countryLabel: "Burkina Faso",
    label: "Burkinabe",
    code: "BFA"
  },
  {
    countryLabel: "Burundi",
    label: "Burundian",
    code: "BDI"
  },
  {
    countryLabel: "Cambodia",
    label: "Cambodian",
    code: "KHM"
  },
  {
    countryLabel: "Cameroon",
    label: "Cameroonian",
    code: "CMR"
  },
  {
    countryLabel: "Canada",
    label: "Canadian",
    code: "CAN"
  },
  {
    countryLabel: "Cape Verde",
    label: "Cape Verdean",
    code: "CPV"
  },
  {
    countryLabel: "Cayman Islands",
    label: "Caymanian",
    code: "CYM"
  },
  {
    countryLabel: "Central African Republic",
    label: "Central African",
    code: "CAF"
  },
  {
    countryLabel: "Chad",
    label: "Chadian",
    code: "TCD"
  },
  {
    countryLabel: "Chile",
    label: "Chilean",
    code: "CHL"
  },
  {
    countryLabel: "China, P.R.",
    label: "Chinese",
    code: "CHN"
  },
  {
    countryLabel: "Colombia",
    label: "Colombian",
    code: "COL"
  },
  {
    countryLabel: "Comoros",
    label: "Comoran",
    code: "COM"
  },
  {
    countryLabel: "Congo, Dem. Rep.",
    label: "Congolese (Congo Dem. Rep.)",
    code: "COD"
  },
  {
    countryLabel: "Congo",
    label: "Congolese (Congo)",
    code: "COG"
  },
  {
    countryLabel: "Cook Islands",
    label: "Cook Islander",
    code: "COK"
  },
  {
    countryLabel: "Costa Rica",
    label: "Costa Rican",
    code: "CRI"
  },
  {
    countryLabel: "Croatia",
    label: "Croatian",
    code: "HRV"
  },
  {
    countryLabel: "Cuba",
    label: "Cuban",
    code: "CUB"
  },
  {
    countryLabel: "Curacao",
    label: "Curaçaoan",
    code: "CUW"
  },
  {
    countryLabel: "Cyprus",
    label: "Cypriot",
    code: "CYP"
  },
  {
    countryLabel: "Czechia",
    label: "Czech",
    code: "CZE"
  },
  {
    countryLabel: "Denmark",
    label: "Danish",
    code: "DNK"
  },
  {
    countryLabel: "Djibouti",
    label: "Djiboutian",
    code: "DJI"
  },
  {
    countryLabel: "Dominica",
    label: "Dominican (Dominica)",
    code: "DMA"
  },
  {
    countryLabel: "Dominican Republic",
    label: "Dominican (Dominican Republic)",
    code: "DOM"
  },
  {
    countryLabel: "Netherlands",
    label: "Dutch",
    code: "NLD"
  },
  {
    countryLabel: "Ecuador",
    label: "Ecuadorean",
    code: "ECU"
  },
  {
    countryLabel: "Egypt",
    label: "Egyptian",
    code: "EGY"
  },
  {
    countryLabel: "United Arab Emirates",
    label: "Emirian",
    code: "ARE"
  },
  {
    countryLabel: "Equatorial Guinea",
    label: "Equatorial Guinean",
    code: "GNQ"
  },
  {
    countryLabel: "Eritrea",
    label: "Eritrean",
    code: "ERI"
  },
  {
    countryLabel: "Estonia",
    label: "Estonian",
    code: "EST"
  },
  {
    countryLabel: "Ethiopia",
    label: "Ethiopian",
    code: "ETH"
  },
  {
    countryLabel: "Fiji",
    label: "Fijian",
    code: "FJI"
  },
  {
    countryLabel: "Philippines",
    label: "Filipino",
    code: "PHL"
  },
  {
    countryLabel: "Finland",
    label: "Finnish",
    code: "FIN"
  },
  {
    countryLabel: "France",
    label: "French",
    code: "FRA"
  },
  {
    countryLabel: "French Guiana",
    label: "French Guianese",
    code: "GUF"
  },
  {
    countryLabel: "French Polynesia",
    label: "French Polynesian",
    code: "PYF"
  },
  {
    countryLabel: "Gabon",
    label: "Gabonese",
    code: "GAB"
  },
  {
    countryLabel: "Gambia",
    label: "Gambian",
    code: "GMB"
  },
  {
    countryLabel: "Georgia",
    label: "Georgian",
    code: "GEO"
  },
  {
    countryLabel: "Germany",
    label: "German",
    code: "DEU"
  },
  {
    countryLabel: "Ghana",
    label: "Ghanaian",
    code: "GHA"
  },
  {
    countryLabel: "Gibraltar",
    label: "Gibralterian",
    code: "GIB"
  },
  {
    countryLabel: "Greece",
    label: "Greek",
    code: "GRC"
  },
  {
    countryLabel: "Greenland",
    label: "Greenlander",
    code: "GRL"
  },
  {
    countryLabel: "Grenada",
    label: "Grenadian",
    code: "GRD"
  },
  {
    countryLabel: "Guadeloupe",
    label: "Guadeloupean",
    code: "GLP"
  },
  {
    countryLabel: "Guam",
    label: "Guamanian",
    code: "GUM"
  },
  {
    countryLabel: "Guatemala",
    label: "Guatemalan",
    code: "GTM"
  },
  {
    countryLabel: "Guinea-Bissau",
    label: "Guinean (Guinea-Bissau)",
    code: "GNB"
  },
  {
    countryLabel: "Guinea-Conakry",
    label: "Guinean (Guinea-Conakry)",
    code: "GIN"
  },
  {
    countryLabel: "Guyana",
    label: "Guyanese",
    code: "GUY"
  },
  {
    countryLabel: "Haiti",
    label: "Haitian",
    code: "HTI"
  },
  {
    countryLabel: "Honduras",
    label: "Honduran",
    code: "HND"
  },
  {
    countryLabel: "Hong Kong, China",
    label: "Hong Konger",
    code: "HKG"
  },
  {
    countryLabel: "Hungary",
    label: "Hungarian",
    code: "HUN"
  },
  {
    countryLabel: "Iceland",
    label: "Icelander",
    code: "ISL"
  },
  {
    countryLabel: "Kiribati",
    label: "I-Kiribati",
    code: "KIR"
  },
  {
    countryLabel: "India",
    label: "Indian",
    code: "IND"
  },
  {
    countryLabel: "Indonesia",
    label: "Indonesian",
    code: "IDN"
  },
  {
    countryLabel: "Iran",
    label: "Iranian",
    code: "IRN"
  },
  {
    countryLabel: "Iraq",
    label: "Iraqi",
    code: "IRQ"
  },
  {
    countryLabel: "Ireland",
    label: "Irish",
    code: "IRL"
  },
  {
    countryLabel: "Israel",
    label: "Israeli",
    code: "ISR"
  },
  {
    countryLabel: "Italy",
    label: "Italian",
    code: "ITA"
  },
  {
    countryLabel: "Cote D'Ivoire",
    label: "Ivorian",
    code: "CIV"
  },
  {
    countryLabel: "Jamaica",
    label: "Jamaican",
    code: "JAM"
  },
  {
    countryLabel: "Japan",
    label: "Japanese",
    code: "JPN"
  },
  {
    countryLabel: "Jordan",
    label: "Jordanian",
    code: "JOR"
  },
  {
    countryLabel: "Kazakhstan",
    label: "Kazakhstani",
    code: "KAZ"
  },
  {
    countryLabel: "Kenya",
    label: "Kenyan",
    code: "KEN"
  },
  {
    countryLabel: "St. Kitts & Nevis",
    label: "Kittian",
    code: "KNA"
  },
  {
    countryLabel: "Kosovo",
    label: "Kosovan",
    code: "UNK"
  },
  {
    countryLabel: "Kuwait",
    label: "Kuwaiti",
    code: "KWT"
  },
  {
    countryLabel: "Kyrgyzstan",
    label: "Kyrgyzstani",
    code: "KGZ"
  },
  {
    countryLabel: "Laos",
    label: "Laotian",
    code: "LAO"
  },
  {
    countryLabel: "Latvia",
    label: "Latvian",
    code: "LVA"
  },
  {
    countryLabel: "Lebanon",
    label: "Lebanese",
    code: "LBN"
  },
  {
    countryLabel: "Liberia",
    label: "Liberian",
    code: "LBR"
  },
  {
    countryLabel: "Libya",
    label: "Libyan",
    code: "LBY"
  },
  {
    countryLabel: "Liechtenstein",
    label: "Liechtensteiner",
    code: "LIE"
  },
  {
    countryLabel: "Lithuania",
    label: "Lithunian",
    code: "LTU"
  },
  {
    countryLabel: "Luxembourg",
    label: "Luxembourger",
    code: "LUX"
  },
  {
    countryLabel: "Macau",
    label: "Macanese",
    code: "MAC"
  },
  {
    countryLabel: "North Macedonia",
    label: "Macedonian",
    code: "MKD"
  },
  {
    countryLabel: "Madagascar",
    label: "Malagasy",
    code: "MDG"
  },
  {
    countryLabel: "Malawi",
    label: "Malawian",
    code: "MWI"
  },
  {
    countryLabel: "Malaysia",
    label: "Malaysian",
    code: "MYS"
  },
  {
    countryLabel: "Maldives",
    label: "Maldivan",
    code: "MDV"
  },
  {
    countryLabel: "Mali",
    label: "Malian",
    code: "MLI"
  },
  {
    countryLabel: "Malta",
    label: "Maltese",
    code: "MLT"
  },
  {
    countryLabel: "Marshall Islands",
    label: "Marshallese",
    code: "MHL"
  },
  {
    countryLabel: "Martinique",
    label: "Martinican",
    code: "MTQ"
  },
  {
    countryLabel: "Mauritania",
    label: "Mauritanian",
    code: "MRT"
  },
  {
    countryLabel: "Mauritius",
    label: "Mauritian",
    code: "MUS"
  },
  {
    countryLabel: "Mexico",
    label: "Mexican",
    code: "MEX"
  },
  {
    countryLabel: "Micronesia, Fed. States",
    label: "Micronesian",
    code: "FSM"
  },
  {
    countryLabel: "Moldova",
    label: "Moldovan",
    code: "MDA"
  },
  {
    countryLabel: "Monaco",
    label: "Monacan",
    code: "MCO"
  },
  {
    countryLabel: "Mongolia",
    label: "Mongolian",
    code: "MNG"
  },
  {
    countryLabel: "Montenegro",
    label: "Montenegrin",
    code: "MNE"
  },
  {
    countryLabel: "Montserrat",
    label: "Montserratian",
    code: "MSR"
  },
  {
    countryLabel: "Morocco",
    label: "Moroccan",
    code: "MAR"
  },
  {
    countryLabel: "Lesotho",
    label: "Mosotho",
    code: "LSO"
  },
  {
    countryLabel: "Botswana",
    label: "Motswana",
    code: "BWA"
  },
  {
    countryLabel: "Mozambique",
    label: "Mozambican",
    code: "MOZ"
  },
  {
    countryLabel: "Myanmar",
    label: "Myanmarese",
    code: "MMR"
  },
  {
    countryLabel: "Namibia",
    label: "Namibian",
    code: "NAM"
  },
  {
    countryLabel: "Nauru",
    label: "Nauruan",
    code: "NRU"
  },
  {
    countryLabel: "Nepal",
    label: "Nepalese",
    code: "NPL"
  },
  {
    countryLabel: "New Caledonia",
    label: "New Caledonian",
    code: "NCL"
  },
  {
    countryLabel: "New Zealand",
    label: "New Zealander",
    code: "NZL"
  },
  {
    countryLabel: "Nicaragua",
    label: "Nicaraguan",
    code: "NIC"
  },
  {
    countryLabel: "Nigeria",
    label: "Nigerian",
    code: "NGA"
  },
  {
    countryLabel: "Niger",
    label: "Nigerien",
    code: "NER"
  },
  {
    countryLabel: "Vanuatu",
    label: "Ni-Vanuatu",
    code: "VUT"
  },
  {
    countryLabel: "Norfolk Island",
    label: "Norfolk Islander",
    code: "NFK"
  },
  {
    countryLabel: "Korea, D.P.R.",
    label: "North Korean",
    code: "PRK"
  },
  {
    countryLabel: "Northern Mariana Islands",
    label: "Northern Mariana Islander",
    code: "MNP"
  },
  {
    countryLabel: "Norway",
    label: "Norwegian",
    code: "NOR"
  },
  {
    countryLabel: "Oman",
    label: "Omani",
    code: "OMN"
  },
  {
    countryLabel: "Pacific Oceania",
    label: "Pacific Oceanian",
    code: "POC"
  },
  {
    countryLabel: "Pakistan",
    label: "Pakistani",
    code: "PAK"
  },
  {
    countryLabel: "Palau",
    label: "Palauan",
    code: "PLW"
  },
  {
    countryLabel: "Palestine",
    label: "Palestinian",
    code: "PSE"
  },
  {
    countryLabel: "Panama",
    label: "Panamanian",
    code: "PAN"
  },
  {
    countryLabel: "Papua New Guinea",
    label: "Papua New Guinean",
    code: "PNG"
  },
  {
    countryLabel: "Paraguay",
    label: "Paraguayan",
    code: "PRY"
  },
  {
    countryLabel: "Peru",
    label: "Peruvian",
    code: "PER"
  },
  {
    countryLabel: "Poland",
    label: "Polish",
    code: "POL"
  },
  {
    countryLabel: "Portugal",
    label: "Portuguese",
    code: "PRT"
  },
  {
    countryLabel: "Puerto Rico",
    label: "Puerto Rican",
    code: "PRI"
  },
  {
    countryLabel: "Qatar",
    label: "Qatari",
    code: "QAT"
  },
  {
    countryLabel: "Reunion",
    label: "Reunion",
    code: "REU"
  },
  {
    countryLabel: "Romania",
    label: "Romanian",
    code: "ROU"
  },
  {
    countryLabel: "Russia",
    label: "Russian",
    code: "RUS"
  },
  {
    countryLabel: "Rwanda",
    label: "Rwandan",
    code: "RWA"
  },
  {
    countryLabel: "St. Lucia",
    label: "Saint Lucian",
    code: "LCA"
  },
  {
    countryLabel: "St. Vincent & the Grenadines",
    label: "Saint Vincentian",
    code: "VCT"
  },
  {
    countryLabel: "El Salvador",
    label: "Salvadorean",
    code: "SLV"
  },
  {
    countryLabel: "American Samoa",
    label: "Samoan (American Samoa)",
    code: "ASM"
  },
  {
    countryLabel: "Samoa",
    label: "Samoan (Samoa)",
    code: "WSM"
  },
  {
    countryLabel: "San Marino",
    label: "Sanmarinese",
    code: "SMR"
  },
  {
    countryLabel: "Sao Tome & Principe",
    label: "São Tomean",
    code: "STP"
  },
  {
    countryLabel: "Saudi Arabia",
    label: "Saudi Arabian",
    code: "SAU"
  },
  {
    countryLabel: "Senegal",
    label: "Senegalese",
    code: "SEN"
  },
  {
    countryLabel: "Serbia",
    label: "Serbian",
    code: "SRB"
  },
  {
    countryLabel: "Seychelles",
    label: "Seychellois",
    code: "SYC"
  },
  {
    countryLabel: "Sierra Leone",
    label: "Sierra Leonean",
    code: "SLE"
  },
  {
    countryLabel: "Singapore",
    label: "Singaporean",
    code: "SGP"
  },
  {
    countryLabel: "Sint Maarte",
    label: "Sint Maartener",
    code: "SXM"
  },
  {
    countryLabel: "Slovakia",
    label: "Slovakian",
    code: "SVK"
  },
  {
    countryLabel: "Slovenia",
    label: "Slovenian",
    code: "SVN"
  },
  {
    countryLabel: "Solomon Islands",
    label: "Solomon Islander",
    code: "SLB"
  },
  {
    countryLabel: "Somalia",
    label: "Somali",
    code: "SOM"
  },
  {
    countryLabel: "South Africa",
    label: "South African",
    code: "ZAF"
  },
  {
    countryLabel: "Korea, Rep.",
    label: "South Korean",
    code: "KOR"
  },
  {
    countryLabel: "Spain",
    label: "Spanish",
    code: "ESP"
  },
  {
    countryLabel: "Sri Lanka",
    label: "Sri Lankan",
    code: "LKA"
  },
  {
    countryLabel: "Sudan",
    label: "Sudanese",
    code: "SDN"
  },
  {
    countryLabel: "Surinam",
    label: "Surinamer",
    code: "SUR"
  },
  {
    countryLabel: "eSwatini",
    label: "Swazi",
    code: "SWZ"
  },
  {
    countryLabel: "Sweden",
    label: "Swedish",
    code: "SWE"
  },
  {
    countryLabel: "Switzerland",
    label: "Swiss",
    code: "CHE"
  },
  {
    countryLabel: "Syria",
    label: "Syrian",
    code: "SYR"
  },
  {
    countryLabel: "Tahiti",
    label: "Tahitian",
    code: null
  },
  {
    countryLabel: "Chinese Taipei",
    label: "Taiwanese",
    code: "TWN"
  },
  {
    countryLabel: "Tajikistan",
    label: "Tajikistani",
    code: "TJK"
  },
  {
    countryLabel: "Tanzania",
    label: "Tanzanian",
    code: "TZA"
  },
  {
    countryLabel: "Thailand",
    label: "Thai",
    code: "THA"
  },
  {
    countryLabel: "Timor-Leste",
    label: "Timorese",
    code: "TLS"
  },
  {
    countryLabel: "Togo",
    label: "Togolese",
    code: "TGO"
  },
  {
    countryLabel: "Tonga",
    label: "Tongan",
    code: "TON"
  },
  {
    countryLabel: "Trinidad & Tobago",
    label: "Trinidadian",
    code: "TTO"
  },
  {
    countryLabel: "Tunisia",
    label: "Tunisian",
    code: "TUN"
  },
  {
    countryLabel: "Turkiye",
    label: "Turkish",
    code: "TUR"
  },
  {
    countryLabel: "Turkmenistan",
    label: "Turkmen",
    code: "TKM"
  },
  {
    countryLabel: "Turks & Caicos Islands",
    label: "Turks and Caicos Islander",
    code: "TCA"
  },
  {
    countryLabel: "Tuvalu",
    label: "Tuvaluan",
    code: "TUV"
  },
  {
    countryLabel: "Uganda",
    label: "Ugandan",
    code: "UGA"
  },
  {
    countryLabel: "Ukraine",
    label: "Ukrainian",
    code: "UKR"
  },
  {
    countryLabel: "Uruguay",
    label: "Uruguayan",
    code: "URY"
  },
  {
    countryLabel: "Uzbekistan",
    label: "Uzbekistani",
    code: "UZB"
  },
  {
    countryLabel: "Venezuela",
    label: "Venezuelan",
    code: "VEN"
  },
  {
    countryLabel: "Vietnam",
    label: "Vietnamese",
    code: "VNM"
  },
  {
    countryLabel: "British Virgin Islands",
    label: "Virgin Islander (British Virgin Islands)",
    code: "VGB"
  },
  {
    countryLabel: "US Virgin Islands",
    label: "Virgin Islander (US Virgin Islands)",
    code: "VIR"
  },
  {
    countryLabel: "Yemen",
    label: "Yemeni",
    code: "YEM"
  },
  {
    countryLabel: "Zambia",
    label: "Zambian",
    code: "ZMB"
  },
  {
    countryLabel: "Zimbabwe",
    label: "Zimbabwean",
    code: "ZWE"
  }
];
